import { Popconfirm } from 'antd';

export const AntPopconfirm = Popconfirm;
